import { Routes, Route } from "react-router-dom";
import MemberShips from "src/modules/MemberShips";
import SignNow from "src/modules/SignNow";
import Login from "src/modules/WebScreens/Login";
import { PUBLIC_ROUTES } from "src/utils/constants";

const NoAuthRoutes = () => {
  return (
    <Routes>
      <Route path={PUBLIC_ROUTES.MEMBERSHIPS} element={<MemberShips />} />
      <Route path={PUBLIC_ROUTES.ORG_LOGIN} element={<Login />} />
      <Route path={PUBLIC_ROUTES.CLIENT_LOGIN} element={<Login />} />
      <Route path={"/"} element={<Login />} />
      <Route path={PUBLIC_ROUTES.SIGN_NOW} element={<SignNow />} />
    </Routes>
  );
};

export default NoAuthRoutes;
